import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonials.css";
import { FaQuoteLeft } from "react-icons/fa";

const testimonials = [
  {
    name: "Rajender Bathla",
    quote:
      "This organization is excellent in making innovative marketing strategies and satisfying their clients with the best services."
  },
  {
    name: "Shalu Verma",
    quote:
      "I am using their point of sale system for my retail showroom and I am really very happy. The application has solved a lot of my problems and the product is really very good. Thanks to Amit ji for your guidance and support."
  },
  {
    name: "Simran Singh",
    quote:
      "ISOLS Group is the best marketing company. They have helped me to achieve maximum excellence by giving better digital marketing solutions for my venture and stay competitive. I fully recommend them as a reliable partner."
  },
  {
    name: "Appoorv Sharma",
    quote:
      "ISOLS Group is the best supporting hand to expand the business through their digital ideas and strategies. This is the most trustful group for digital marketing strategies that helps in growing the business. They are superb at their work."
  },
  {
    name: "Rupal Tayal",
    quote:
      "ISOLS Group is one of the best companies that helps with business ideas and strategies. They are very supportive and help in growing your business. They are truthful and do brilliant work."
  },
  {
    name: "RP Shanu",
    quote: "A group of talented people having perfect knowledge of Digital Marketing."
  },
  {
    name: "Ruchika Garg",
    quote:
      "ISOLS Group is the best supporting hand to expand the business. Through their digital strategies and ideas we can increase our business to great heights. They are superb at their work."
  },
  {
    name: "Anshika Jain",
    quote:
      "The organisation is excellent for digital marketing. They can give you unique techniques to grow your business. They have turned many start ups into big companies."
  },
  {
    name: "Stuti Gulati",
    quote:
      "This group has helped many start-ups to reach the peaks of the corporate world by providing innovative marketing strategies and best ideas to make your business successful."
  },
  {
    name: "Neelu Bathla",
    quote:
      "Great organisation for everyone connected with them whether they are clients, employees or interns. They treat everyone so nicely and they are very humble being the best digital marketing organisation."
  }
];

const Testimonials = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    adaptiveHeight: true
  };

  return (
    <section className="section-about" style={{ marginBottom: "60px" }}>
      <div className="b-home-testimonials">
        <div className="b-testimonials">
          <div className="container-fluid">
            <div className="row">
              {/* Left side */}
              <div className="col-xs-12 col-sm-4 left-side">
                <div className="b-services-item">
                  <div className="services-icon">
                    <img
                      src="/images/services_testimonials.png"
                      alt="CLIENTS SPEAK"
                    />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      CLIENTS SPEAK
                    </h6>
                    <p>We sincerely value their words.</p>
                  </div>
                </div>
              </div>

              {/* Right side slider */}
              <div className="col-xs-12 col-sm-8 right-side">
                <Slider {...settings}>
                  {testimonials.map((t, i) => (
                    <div key={i} className="testimonials-item">
                      <div className="testimonials-caption b-blockquote-bg">
                        <div className="quote-content">
                          <p className="quote-text">
                            <FaQuoteLeft className="quote-icon" /> {t.quote}
                          </p>
                          <p className="quote-author">
                            <span className="author-name">{t.name}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
